"use strict";
/** Gold αναφορές — μία πηγή για billing, routes και mobile */
Object.defineProperty(exports, "__esModule", { value: true });
exports.goldReportCatalog = exports.goldReportNavSections = exports.goldReportSectionLabels = exports.goldReportSectionPaths = void 0;
exports.goldReportFeatureBullets = goldReportFeatureBullets;
exports.getGoldReportById = getGoldReportById;
exports.goldReportPathForSection = goldReportPathForSection;
const reports_labels_1 = require("./reports-labels");
exports.goldReportSectionPaths = {
    statistics: '/reports',
    weekly: '/reports/weekly',
    insights: '/reports/insights',
    offers: '/reports/offers',
    crm: '/reports/crm',
    operations: '/reports/operations',
    financials: '/reports/financials',
    profile: '/reports/profile',
    compare: '/reports/compare',
};
/** Τίτλοι sidebar / header — ξεχωριστοί από κύρια πλοήγηση (π.χ. «Προσφορές» vs «Αναφορές προσφορών»). */
exports.goldReportSectionLabels = {
    statistics: 'Στατιστικά',
    weekly: 'Εβδομαδιαία σύνοψη',
    offers: 'Αναφορές προσφορών',
    crm: 'Αναφορές CRM',
    operations: 'Υπενθυμίσεις & εργασίες',
    insights: 'Ταχύτητα & ραντεβού',
    financials: 'Οικονομικά',
    profile: 'Δημόσιο προφίλ',
    compare: 'Σύγκριση περιόδων',
};
const goldReportNavSectionOrder = [
    'statistics',
    'weekly',
    'offers',
    'crm',
    'operations',
    'insights',
    'financials',
    'profile',
    'compare',
];
exports.goldReportNavSections = goldReportNavSectionOrder.map((id) => ({
    id,
    label: exports.goldReportSectionLabels[id],
    path: exports.goldReportSectionPaths[id],
}));
exports.goldReportCatalog = [
    {
        id: 'pipeline',
        title: reports_labels_1.OFFER_PIPELINE_SECTION_TITLE,
        valueLine: 'Ανοιχτές προσφορές, αξία και ημέρες αναμονής',
        sectionId: 'offers',
        tabId: 'offers',
        exportBundle: 'pipeline',
        exportFormats: ['csv'],
    },
    {
        id: 'acceptance',
        title: 'Απόδοση προσφορών',
        valueLine: 'Conversion, εκπρόθεσμες προσφορές και μέσος χρόνος απόφασης',
        sectionId: 'offers',
        tabId: 'offers',
        exportBundle: 'offer-performance',
        exportFormats: ['csv'],
    },
    {
        id: 'crm-funnel',
        title: 'CRM και funnel',
        valueLine: 'Στάδια πελατών, κολλημένοι και top by value',
        sectionId: 'crm',
        tabId: 'crm',
        exportBundle: 'crm',
        exportFormats: ['csv'],
    },
    {
        id: 'tasks',
        title: 'Εκπρόθεσμες εργασίες',
        valueLine: 'Λίστα με πελάτη και προθεσμία για άμεση ενέργεια',
        sectionId: 'operations',
        tabId: 'operations',
        exportBundle: 'tasks',
        exportFormats: ['csv'],
    },
    {
        id: 'follow-up',
        title: 'Follow-up',
        valueLine: 'Funnel αποστολών, αποτυχίες και opt-out',
        sectionId: 'operations',
        tabId: 'operations',
        exportBundle: 'follow-up',
        exportFormats: ['csv'],
    },
    {
        id: 'financials',
        title: 'Οικονομικά και margin',
        valueLine: 'Έξοδα ανά μήνα και margin ανά έργο',
        sectionId: 'financials',
        tabId: 'financials',
        exportBundle: 'financials',
        exportFormats: ['csv'],
    },
    {
        id: 'profile',
        title: 'Δημόσιο προφίλ',
        valueLine: 'Προβολές, QR, CTA και αξιολογήσεις',
        sectionId: 'profile',
        tabId: 'profile',
        exportBundle: 'profile',
        exportFormats: ['csv'],
    },
    {
        id: 'compare',
        title: 'Σύγκριση περιόδων',
        valueLine: 'Τρέχουσα vs προηγούμενη περίοδος ίδιου μήκους',
        sectionId: 'compare',
        tabId: 'compare',
    },
    {
        id: 'insights-bundle',
        title: 'Ταχύτητα & ραντεβού',
        valueLine: 'Ταχύτητα προσφορών, κορυφαίοι πελάτες και ραντεβού περιόδου',
        sectionId: 'insights',
        tabId: 'insights',
    },
    {
        id: 'weekly-summary',
        title: 'Εβδομαδιαία σύνοψη',
        valueLine: 'KPI περιόδου και προτεραιότητες ενεργειών για τη διοίκηση',
        sectionId: 'weekly',
        tabId: 'weekly',
        exportBundle: 'weekly-summary',
        exportFormats: ['pdf'],
    },
    {
        id: 'executive',
        title: 'Εξαγωγή PDF (Στατιστικά)',
        valueLine: 'Πλήρης σελίδα επισκόπησης — KPI, καταστάσεις προσφορών, στάδια πελατών και margin έργων',
        sectionId: 'statistics',
        tabId: 'statistics',
        exportBundle: 'statistics',
        exportFormats: ['pdf'],
    },
];
function goldReportFeatureBullets() {
    return [
        'Περιλαμβάνει όλα του Pro',
        'Widget στατιστικών στην αρχική (pipeline, αποδοχή, εργασίες, έξοδα)',
        ...exports.goldReportCatalog.map((r) => r.title),
        'Εξαγωγές CSV ανά αναφορά, executive PDF και share από κινητό',
    ];
}
function getGoldReportById(id) {
    return exports.goldReportCatalog.find((r) => r.id === id);
}
function goldReportPathForSection(sectionId) {
    return exports.goldReportSectionPaths[sectionId];
}
